// extracted by mini-css-extract-plugin
export default {"products_menu":"products_menu___BxTqS","show":"show___AQbaF","closed":"closed___SJ_qE"};